import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-double-right-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.613 11.3l-4.919-5a1.007 1.007 0 0 0-.714-.3h-4.009a1 1 0 0 0-.712 1.7l4.057 4.123a.252.252 0 0 1 0 .351L13.259 16.3a1 1 0 0 0 .712 1.7h4.009a1 1 0 0 0 .713-.3l4.92-5a1 1 0 0 0 0-1.4z"/><path pid="1" d="M14.142 11.3l-4.919-5A1.006 1.006 0 0 0 8.51 6H6.984a1 1 0 0 0-.713 1.7l4.058 4.123a.25.25 0 0 1 0 .351L6.271 16.3a1 1 0 0 0 .713 1.7H8.51a1 1 0 0 0 .712-.3l4.92-5a1 1 0 0 0 0-1.4z"/><path pid="2" d="M6.384 10.947L1.814 6.3A1 1 0 0 0 .388 7.7l4.052 4.122a.251.251 0 0 1 0 .351L.388 16.3a1 1 0 0 0 1.426 1.4l4.569-4.65a1.508 1.508 0 0 0 .001-2.103z"/>`,
    },
});
